import { InjectionKey } from 'vue';

export const dropdownListInjectionKey = Symbol() as InjectionKey<{
  close: () => void;
}>;
